module.exports = __webpack_public_path__ + "media/images/icons/no_rating_responsibility-912fd5c77e015f043240f4a3fe196259.svg";